import { DisplayTabs } from "./Tab";
export function createEmptyData() {
    return new Map(DisplayTabs.map(function (tab) { return [tab, { pageCache: [], rows: [], fetching: false }]; }));
}
